import React , { Fragment , useContext , useState } from 'react' ;


import axios from "axios";
import { useFormik } from "formik" ;
import toast from "react-hot-toast" ;
import {useLocation, useNavigate } from "react-router-dom" ;
import * as Yup from 'yup';
import { UserContext } from '../../Context/UserContext.js' ;
import style from "./completeProfile.module.css" ;
import { jwtDecode } from 'jwt-decode';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';

export default function CompleteProfile() {

      //^ Use Query Params :
      const location = useLocation();
      const query = new URLSearchParams(location.search);
      const order = query.get("order");



   let navigate = useNavigate() ;
   const [error , setError] = useState(null) ;
   const [loading , setLoading] = useState(false) ;
   const [showPassword, setShowPassword] = useState(false) ;
   const {setLoggedUser , setUserToken  , setCompleteInfoUser} = useContext(UserContext)

   
	const {userToken } = useContext(UserContext)
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   } ;



   async function submitCompleteRegister(values){
      setLoading(true)
      await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/users/completeProfile` , values , {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setLoading(false) ;
            localStorage.setItem("token" , data.token) ;
            setUserToken(data.token)

            const token = data.token; 
            let decoded = jwtDecode(token);
            setLoggedUser(decoded) ;
            setCompleteInfoUser(true) ;

            if(order === "true"){
               navigate("/order") ;
            }else{
               navigate("/home") ;
            }
            
         }
      })
      .catch((error)=>{
         setLoading(false) ;
         setError(error.response.data.message) ;
         toast.error(error.response.data.message) ;
      })
   } ;




   let validationSchema = Yup.object({
      phone:Yup.string().required().matches(/^01[0125][0-9]{8}$/).trim() ,
      birthDay:Yup.string().required().trim() ,
      gender: Yup.string().oneOf(['male', 'female'], 'Required Male or Female').required('Gender Required') ,
      password:Yup.string().required().matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]?).{8,}$/ , "Should be Password Start UpperCase And Contain 8 Character And Contain any (@#$%&*)") ,
      rePassword:Yup.string().oneOf([Yup.ref("password")]  , "rePassword Should be Same Password").required() ,
   }) ;



   let formik = useFormik({
      initialValues:{
         phone:"" ,
         birthDay:"" ,
         gender:"" ,
         password:"" ,
         rePassword:"" ,
      } , validationSchema , 
      onSubmit:submitCompleteRegister
   }) ;

   return (
      <Fragment>
         <CustomTitle title="تعديل البيانات الشخصة" />
         <div className="register-container p-3 m-auto mt-5">
            <h1 className="main-header">تكملة البيانات للمستخدم</h1>
            <p className="sub-title text-center">Enter Good Information Please !</p>


            <div className="row">
               <div className="col-md-8 offset-md-2">
                  <form action="" onSubmit={formik.handleSubmit}>
                     {error?<div className="alert alert-danger w-75  my-4">{error}</div> :""}


                     <div className="my-4 position-relative">
                        <i className="fa-solid fa-mobile-screen-button icon-input-field"></i>
                        <label htmlFor="phone" className="form-label required">Enter User Phone</label>
                        {/* <input type="tel"  */}
                        <input type="text" 
                           value={formik.values.phone}
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           className="form-control" id="phone"  
                           name="phone" 
                           required
                           placeholder="01X XXX XXX XX" />
                        {formik.errors.phone && formik.touched.phone?<div className="text-danger m-0 p-0">{formik.errors.phone}</div> :""}
                     </div>


                     <div className="my-4 position-relative">
                        <i className="fa-solid fa-cake-candles icon-input-field"></i>
                        <label htmlFor="birthDay" className="form-label required">Enter User birthDay</label>
                        {/* <input type="tel"  */}
                        <input type="date" 
                           value={formik.values.birthDay}
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           className="form-control" id="birthDay"  
                           name="birthDay" 
                           required
                           placeholder="xxxx-xx-xx" />
                        {formik.errors.birthDay && formik.touched.birthDay?<div className="text-danger m-0 p-0">{formik.errors.birthDay}</div> :""}
                     </div>

                     

                     <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" 
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           value="male"
                           id="male"
                           name="gender" />
                        <label className="form-check-label" htmlFor="male">ّذكر </label>
                           {formik.errors.gender && formik.touched.gender?<div className="alert alert-danger mt-4 p-2">{formik.errors.gender}</div> :""}
                     </div>


                     <div className="form-check form-check-inline mx-5">
                        <input className="form-check-input" type="radio" 
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           value="female"
                           id="female"
                           name="gender" />
                        <label className="form-check-label" htmlFor="female">أنثى</label>
                           {formik.errors.gender && formik.touched.gender?<div className="alert alert-danger mt-4 p-2">{formik.errors.gender}</div> :""}
                     </div>


                     <div className="my-4 position-relative">
                        <i className="fas fa-lock icon-input-field"></i>
                        <label htmlFor="password" className="form-label required">Enter User Password</label>
                        <input type={showPassword ? "text" : "password"} 
                           value={formik.values.password}
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           className="form-control" id="password"  
                           name="password" 
                           required
                           autoComplete="new-password"
                           placeholder="Enter Password" 
                           
                           /** ==== Prevent Copy , Cut , paste , Right Click ==== */
                           onCopy={(e) => e.preventDefault()}
                           onPaste={(e) => e.preventDefault()}
                           onCut={(e) => e.preventDefault()}
                           onContextMenu={(e) => e.preventDefault()}
                        />
                        {formik.errors.password && formik.touched.password?<div className="text-danger m-0 p-0">{formik.errors.password}</div> :""}
                        <i className="fas fa-eye toggle-password"></i>

                        {showPassword ? (
                              <i className="fas fa-eye toggle-password" onClick={() => setShowPassword(false)}></i>
                           ) : (
                              <i className="fas fa-eye-slash toggle-password" onClick={() => setShowPassword(true)}></i>
                           )
                        }
                     </div>


                     <div className="my-4 position-relative">
                        <i className="fa-solid fa-unlock-keyhole  icon-input-field"></i>
                        <label htmlFor="rePassword" className="form-label required">Enter User rePassword</label>
                        <input type={showPassword ? "text" : "password"} 
                           value={formik.values.rePassword}
                           onChange={formik.handleChange} 
                           onBlur={formik.handleBlur}
                           className="form-control" id="rePassword"  
                           name="rePassword" 
                           required
                           autocomplete="new-password"
                           placeholder="Enter rePassword" 
                           
                           /** ==== Prevent Copy , Cut , paste , Right Click ==== */
                           onCopy={(e) => e.preventDefault()}
                           onPaste={(e) => e.preventDefault()}
                           onCut={(e) => e.preventDefault()}
                           onContextMenu={(e) => e.preventDefault()}
                           />
                        {formik.errors.rePassword && formik.touched.rePassword?<div className="text-danger m-0 p-0">{formik.errors.rePassword}</div> :""}
                     </div>



                     <div className="d-grid gap-2 col-8 mx-auto">
                        {loading ? 
                              <button className="btn bg-main text-white mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button>
                           : 
                              <button disabled={!(formik.isValid && formik.dirty)} type="submit" className="btn bg-main text-white mt-2">تكملة البيانات</button>
                        }
                     </div>
                     
                  </form>
               </div>
            </div>

         </div>
      </Fragment>
   )
} 



